const morphologyFeaturesPlus = require('./morphology_features_plus')
var morphologyIdDict = {}
morphologyFeaturesPlus.all_list_names.forEach(listName => {
  morphologyFeaturesPlus[listName].forEach(feature => {
    morphologyIdDict[feature.code] = feature.desc
  })
})

const dictaTokenToReadable = require('./AllDictaTokensToFullForms')

export function prettyPrint (featureName) {
  function dictLookup (term) {
    // get rid of leading @
    const morphArray = term.substring(1).split('#')
    // first element might be the lemma if present
    const lemma = morphArray.shift()

    const lemmaPrint = lemma ? lemma.replace(/[=/[]+/, '') + ' - ' : ''
    return lemmaPrint + morphArray.map(
      function (item) { return morphologyIdDict.hasOwnProperty(item) ? morphologyIdDict[item] : item }
    ).join(', ')
  }
  // remove prefixes that distinguish feature set types if the server is sending them
  featureName = featureName.replace(/@(ml|ms|so|sc|sp)/g, '@')

  // we match things that look like morphology - @ followed by any text until #, then a series of terms starting with #
  featureName = featureName.replace(/@([^ #]*)(#[A-Z0-9_]+)+/g, dictLookup).replace(/_$/, '')

  // we match things that look like syntax clause types, @ followed by 4 chars
  featureName = featureName.replace(/@[A-Za-z0-9]{4}\b/g, x => morphologyIdDict.hasOwnProperty(x) ? morphologyIdDict[x] : x)

  function syntaxPhraseSeqLookup (seq) {
    // get rid of leading @
    const seqArray = seq.substring(1).split('_')
    return seqArray.map(x => morphologyIdDict.hasOwnProperty(x) ? morphologyIdDict[x] : x)
      .join(', ')
  }
  // match things that look like syntax phrase sequences, @ followed by groups of 4 chars joined with _
  featureName = featureName.replace(/@\w{4}(_\w{4})*/g, syntaxPhraseSeqLookup)
  if (featureName.startsWith('lexeme:')) featureName = featureName.substr(7).replace(/[@=[/]/g, '').replace('_aramaic', ' (Aramaic)') + ' (lexeme)'
  if (dictaTokenToReadable.hasOwnProperty(featureName)) {
    featureName = dictaTokenToReadable[featureName]
  }
  return featureName
}

const lexemeToSuppInfo = require('./tanakh_lexemes')

export function lexemeSupps (lexemeName) {
  if (lexemeName.startsWith('lexeme:')) {
    lexemeName = lexemeName.substring(7)
  }
  if (lexemeName.startsWith('@')) {
    lexemeName = lexemeName.substring(1)
  }
  var info
  if (lexemeName in lexemeToSuppInfo) {
    info = lexemeToSuppInfo[lexemeName]
    // info.type = lexemeTypes[info.type]
  } else {
    info = {'eng': 'unknown word', 'type': 'unknown type'}
  }
  return info
}



// WEBPACK FOOTER //
// ./src/mixins/featureNames.js